export default __webpack_public_path__ + "assets/e6b4f8288d114b767fd9d3ca374317fa.svg";